import { useApiContext } from 'react-easyrocket';
import { useEffect } from 'react';
import { smarticoLogout } from 'src/utils/smartico';
import { useQueryClient } from '@tanstack/react-query';

export const useDoSomethingOnLogout = () => {
  const { isAuthenticated } = useApiContext();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isAuthenticated) {
      smarticoLogout();
      queryClient.removeQueries({ queryKey: ['full-info'] });
      queryClient.resetQueries({ queryKey: ['deposit-methods'] });
    }
  }, [isAuthenticated]);
};
